import { render } from "./PlayoutControls.vue?vue&type=template&id=037622ce"
import script from "./PlayoutControls.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutControls.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "037622ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('037622ce', __exports__)) {
    api.reload('037622ce', __exports__)
  }
  
  module.hot.accept("./PlayoutControls.vue?vue&type=template&id=037622ce", () => {
    api.rerender('037622ce', render)
  })

}


export default __exports__